export default __webpack_public_path__ + "static/media/plus-icon.a9325e3b.svg";